import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SocialProof from '../components/SocialProof';
import VideoSection from '../components/VideoSection';
import About from '../components/About';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import Differentials from '../components/Differentials';
import Location from '../components/Location';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  return (
    <div className="App">
      <Header />
      <Hero />
      <SocialProof />
      <VideoSection />
      <About />
      <Services />
      <Gallery />
      <Differentials />
      <Location />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
